import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgent } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const useRunWorkflow = ({ onSuccess, type, title }) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: () => AIAgent.run({ type }),
    onSuccess: (run) => {
      UserNotification.success(
        `Workflow "${title}" is running. It may take a few minutes; the run updates as it progresses.`,
        "AI Agent Workflow"
      );
      if (run == null ? void 0 : run.id) {
        queryClient.setQueryData(["aiagent", "workflow-runs", "detail", run.id], run);
      }
      queryClient.invalidateQueries({ queryKey: ["aiagent", "workflow-runs"] });
      onSuccess();
    },
    onError: (error) => {
      if ((error == null ? void 0 : error.status) === 409) {
        UserNotification.warning(
          `A run of workflow "${title}" is already in progress.`,
          "AI Agent Workflow"
        );
        queryClient.invalidateQueries({ queryKey: WORKFLOW_DEFINITIONS_QUERY_KEY });
        return;
      }
      UserNotification.error(
        `Starting workflow failed: ${error instanceof Error ? error.message : String(error)}`,
        "AI Agent Workflow"
      );
    }
  });
  return { mutate, isPending };
};
export default useRunWorkflow;
